/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAzureEaApplication extends models.ServiceAccountCredentialsBaseForAzureApplication {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAzureEaApplication");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAzureEaApplication.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAzureEaApplication>): ServiceAccountCredentialsForAzureEaApplication {
        let obj = Object.assign(new ServiceAccountCredentialsForAzureEaApplication(), model);
        ServiceAccountCredentialsForAzureEaApplication.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAzureEaApplication>): ServiceAccountCredentialsForAzureEaApplication {
        if (!model) return null;
        return ServiceAccountCredentialsForAzureEaApplication.newInstance(<ServiceAccountCredentialsForAzureEaApplication> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAzureEaApplication) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAzureEaApplication.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAzureEaApplication): boolean {
        if (models.ServiceAccountCredentialsBaseForAzureApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAzureEaApplication.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
